<template>
  <div class="new-detail">
    <div class="title van-multi-ellipsis--l2">{{ info.newsInfoTitle }}</div>
    <div class="basic-info">
      <span>{{ info.newsInfoCreateUserName }}</span>
      <span>{{ info.newsInfoCreateTime | formatDate('yyyy/MM/dd hh:mm') }}</span>
    </div>
    <div class="container-news" v-html="info.contentString"></div>

    <ul v-if="info && info.attrVos" class="attr-list">
      <li class="link" v-for="attrItem in info.attrVos" :key="attrItem.id">
        <a v-if="isIOS" style="color: #007aff" :href="attrItem.url">{{ attrItem.name }} </a>
        <a v-else-if="appVersion === 'dd'" style="color: #007aff" :href="attrItem.url">{{ attrItem.name }} </a>
        <span v-else @click="handleOpenUrl(attrItem.url)">{{ attrItem.name }}</span>
      </li>
    </ul>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getNewsDetail} from '@/api'
import {getIsIOS} from '@/ultis'
export default {
  data() {
    return {
      id: this.$route.params.id,
      info: {},
      pdfh5: null,
      isIOS: getIsIOS()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getNewsDetail({id: this.id}).then(res => {
        this.info = res.data
      })
    },
    handleOpenUrl(url) {
      this.$router.push(`/pdf?url=${url}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.new-detail {
  padding: 16px;
}
.title {
  font-size: 20px;
  font-weight: 500;
  color: #222222;
  margin-bottom: 10px;
}
.attr-list {
  li {
    color: #007aff;
  }
}
.basic-info {
  span {
    color: #888888;
    font-size: 13px;
    margin-right: 10px;
  }
}
img {
  width: 100%;
}
.container-news {
  word-break: break-all;
}
</style>
<style lang="scss">
.new-detail .container-news * {
  display: inline-block;
  max-width: 100%;
}
</style>
